import { createListenerMiddleware } from '@reduxjs/toolkit'

import { postAcceptAgentV2MatterArtifactEdit } from '@/agent-v2/artifact-edit-review/fetch/post-accept-agent-v2-matter-artifact-edit'
import { AgentV2ConversationsActions } from '@/agent-v2/conversations/store/slice'
import { AgentV2TranscriptActions } from '@/agent-v2/store/slice'
import { GlobalToastType } from '@/constants/constants-ui'
import { MatterArtifactsActions } from '@/matter-artifacts/store/slice'
import type { AppDispatch, RootState } from '@/store/store'
import { openGlobalToast } from '@/store/slices/global-toast.slice'
import { AgentV2MatterArtifactEditProposalActions, AgentV2MatterArtifactEditProposalPhase } from './slice'

export const agentV2MatterArtifactEditProposalListenerMiddleware = createListenerMiddleware()
const startListener = agentV2MatterArtifactEditProposalListenerMiddleware.startListening.withTypes<RootState, AppDispatch>()

startListener({
  actionCreator: AgentV2MatterArtifactEditProposalActions.acceptanceRequested,
  effect: async (action, listenerApi) => {
    const originalProposal = listenerApi.getOriginalState().agentV2MatterArtifactEditProposalsState.byConversationId[action.payload.conversationId]
    const proposal = listenerApi.getState().agentV2MatterArtifactEditProposalsState.byConversationId[action.payload.conversationId]
    if (
      originalProposal?.phase === AgentV2MatterArtifactEditProposalPhase.ACCEPTING ||
      proposal?.proposalId !== action.payload.proposalId ||
      proposal.phase !== AgentV2MatterArtifactEditProposalPhase.ACCEPTING ||
      proposal.acceptingOperation !== action.payload.operation
    ) {
      return
    }

    try {
      const acceptedVersion = await postAcceptAgentV2MatterArtifactEdit(
        {
          proposal_id: proposal.proposalId,
          originating_turn_id: proposal.originatingTurnId,
          source_matter_artifact_version_id: proposal.sourceMatterArtifactVersionId,
          operation: action.payload.operation,
          replacement_markdown: proposal.replacementMarkdown,
        },
        proposal.matterArtifactId
      )
      const currentProposal = listenerApi.getState().agentV2MatterArtifactEditProposalsState.byConversationId[proposal.conversationId]
      if (currentProposal?.proposalId !== proposal.proposalId) return

      listenerApi.dispatch(
        AgentV2TranscriptActions.matterArtifactEditAccepted({
          conversationId: proposal.conversationId,
          turnId: proposal.originatingTurnId,
          resultMatterArtifactVersionId: acceptedVersion.id,
        })
      )
      listenerApi.dispatch(
        AgentV2MatterArtifactEditProposalActions.acceptanceSucceeded({
          conversationId: proposal.conversationId,
          proposalId: proposal.proposalId,
        })
      )
      listenerApi.dispatch(MatterArtifactsActions.upsertMatterArtifactVersion(acceptedVersion))
      listenerApi.dispatch(AgentV2ConversationsActions.fetchConversationDetail({ conversationId: proposal.conversationId, forceRefresh: true }))
    } catch {
      const currentProposal = listenerApi.getState().agentV2MatterArtifactEditProposalsState.byConversationId[proposal.conversationId]
      if (currentProposal?.proposalId !== proposal.proposalId) return

      listenerApi.dispatch(
        AgentV2MatterArtifactEditProposalActions.acceptanceFailed({
          conversationId: proposal.conversationId,
          proposalId: proposal.proposalId,
        })
      )
      listenerApi.dispatch(
        openGlobalToast({
          type: GlobalToastType.ERROR,
          message: 'We couldn’t apply this edit.',
        })
      )
    }
  },
})
